<div class="getTheAppToast" *ngIf="!closed">
    <fa-icon [icon]="['fas','times']" style="color:#fff; float:right; margin:2px; margin-right:8px;padding:2px;font-size:20px;" (click)="close()"></fa-icon>

    <div class="d-flex flex-row justify-content-center mx-2">
        <div class="d-flex flex-row justify-content-center">
            <div class="appLogo my-3 mx-1">
                <div>IFA</div>
            </div>
            <div class="my-3 text-light ms-1"><span class="f-18">Index Fund Advisors</span><br>
                <span >Wealth Management &bull; Taxes</span></div>
        </div>

        <!-- <a class="btn btn-primary btn-lg my-3 me-2" href="{{link}}" target="_blank">Get the app</a> -->
    </div>
    <div class="d-flex flex-column justify-content-center">
        <p class="text-center text-light">For an optimized mobile experience.</p>
         <div class="btn btn-primary btn-lg my-3 mx-4 mb-2" (click)="deepLink()">Open in App</div>
          <a class="btn btn-primary btn-lg my-3 mx-4 mb-5" [href]="link">Download App</a>
         <div class="btn btn-primary btn-lg my-3 mx-4" (click)="close()">Open in Browser</div>
        <div class="form-check text-center text-light d-flex flex-row justify-content-center mt-3">  
            <input class="form-check-input" type="checkbox" value="" id="rememberChoice" [(ngModel)]="rememberChoice">  
            <label class="form-check-label ms-2" for="rememberChoice">  
                Remember my choice  
            </label>  
            </div>  
    </div>


</div>